export enum actionTypes {
    LOTTO_START = 'LOTTO:START',
    LOTTO_STOP = 'LOTTO:STOP',
    LOTTO_RENDER_START = 'LOTTO:RENDER:START',
    LOTTO_INITIALIZE_ERROR = 'LOTTO:INITIALIZE:ERROR',
    LOTTO_INITIALIZED_UPDATE = 'LOTTO:INITIALIZED:UPDATE',
    LOTTO_INITIALIZING_UPDATE = 'LOTTO:INITIALIZING:UPDATE',
    LOTTO_INTEGRATION_SCRIPT_ERROR = 'LOTTO:INTEGRATION_SCRIPT:ERROR',
    LOTTO_INTEGRATION_SCRIPT_UPDATE = 'LOTTO:INTEGRATION_SCRIPT:UPDATE',
    LOTTO_INTEGRATION_SCRIPT_FETCHED = 'LOTTO:INTEGRATION_SCRIPT:FETCHED',
    LOTTO_INTEGRATION_SCRIPT_FETCHING = 'LOTTO:INTEGRATION_SCRIPT:FETCHING'
}
